import { defineStore } from '#q-app'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createSentryPiniaPlugin } from '@sentry/vue'

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default defineStore((/* { ssrContext } */) => {
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  if (parseInt(import.meta.env.QCLI_SENTRY_ENABLED) === 1) {
    pinia.use(createSentryPiniaPlugin({ attachPiniaState: false }))
  }
  return pinia
})
